export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-multiple-495e83667da1c0b9bb2fa9b8a799140e.svg";